let _exportName = '';

// k_grid_or_getter: either a Kendo Grid instance, or a function () => grid.
// Passing a getter is preferred — the grid is resolved at click time, so this
// only needs to be called once even if the underlying grid is recreated.
export const resolveGridGetter = (k_grid_or_getter) =>
    typeof k_grid_or_getter === 'function' ? k_grid_or_getter : () => k_grid_or_getter;

export default function(element, k_grid_or_getter, onExport) {
    const $exportSelect = $(element || '.js-export-select');
    if (!$exportSelect.length) return;

    var ddl = $exportSelect.data('kendoDropDownList');
    if (ddl) ddl.destroy();
    $exportSelect.empty();

    const getGrid = resolveGridGetter(k_grid_or_getter);

    const k_exportSelect = $exportSelect
        .kendoDropDownList({
            optionLabel: 'Export As...',
            dataTextField: 'text',
            dataValueField: 'value',
            dataSource: [
                { text: 'Excel', value: 1 },
                { text: 'CSV', value: 2 },
            ],
        })
        .data('kendoDropDownList');

    k_exportSelect.bind('change', function() {
        const value = this.value();
        const ddlInstance = $exportSelect.data('kendoDropDownList');

        if (ddlInstance) {
            ddlInstance.select(0);
        }

        const k_grid = getGrid();

        if (!k_grid && onExport) {
            onExport();
            return;
        }

        if (!k_grid) return;

        if (value === '1') {
            exportToExcel(k_grid);
        } else if (value === '2') {
            exportToCSV(k_grid);
        }
    });

    return k_exportSelect;
}

export const sanitizeWorkbookCellValues = (workbook) => {
    for (const sheet of workbook.sheets) {
        for (const row of sheet.rows) {
            if (!row.cells) continue;
            for (const cell of row.cells) {
                const isDate = cell.value instanceof Date;
                if (cell.value === undefined || (cell.value !== null && typeof cell.value === 'object' && !isDate)) {
                    cell.value = '';
                    continue;
                }
                if (typeof cell.value !== 'string') continue;
                if (cell.value.includes('<')) {
                    const text = cell.value.replace(/<[^>]+>/g, '').trim();
                    const numeric = text.replace(/[$,]/g, '');
                    if (numeric !== '' && !isNaN(numeric)) {
                        cell.value = parseFloat(numeric);
                    } else {
                        cell.value = text;
                    }
                }
                if (typeof cell.value === 'string' && cell.value.includes('&nbsp;')) {
                    cell.value = cell.value.replace(/&nbsp;/g, ' ').trim();
                }
            }
        }
    }
};

export const captureWorkbookSheet = (grid, sheetName) => {
    return new Promise((resolve) => {
        grid.one('excelExport', (e) => {
            e.preventDefault();
            sanitizeWorkbookCellValues(e.workbook);
            const sheet = e.workbook.sheets[0];
            sheet.title = sheetName;
            resolve(sheet);
        });
        grid.saveAsExcel();
    });
};

const exportToExcel = (k_grid) => {
    k_grid.one('excelExport', (e) => {
        sanitizeWorkbookCellValues(e.workbook);
    });
    k_grid.saveAsExcel();
}

const exportToCSV = (k_grid, columnParser) => {
    let columns = k_grid.columns, data = k_grid.dataSource.view(), csv = '', dateTime = new Date(),
        fileName = _exportName + 'Export_' + dateTime.getFullYear() + (dateTime.getMonth() + 1) + dateTime.getDate() + '.csv';
    $.each(columns, function (index, item) {
        let field = item.title || item.field;
        if (field) {
            csv += field + ',';
        }
    });

    csv += '\n';

    $.each(data, function (index, item) {
        columns.forEach(function (ele) {
            let field = ele.field;
            if (field) {
                csv += (item[ele.field] || '') + ',';
            }
        });
        csv += '\n';
    });

    if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(new Blob([csv], {type: 'text/csv;charset=utf-8;'}), fileName);
    } else {
        let encodedUri = 'data:text/csv;charset=utf-8,' + escape(csv);
        let link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}